var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3665 5.00029C17.8941 5.95322 19.068 7.3797 19.7092 9.06211C20.3503 10.7445 20.4235 12.5905 19.9176 14.3184C19.4116 16.0462 18.3543 17.5612 16.907 18.632C15.4596 19.7029 13.7017 20.2709 11.9014 20.2494C10.1011 20.2279 8.35726 19.618 6.93592 18.5129C5.51459 17.4077 4.4938 15.8679 4.0293 14.1285C3.56479 12.389 3.68207 10.5453 4.36325 8.8787C5.04442 7.2121 6.25209 5.81408 7.80201 4.89793",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10V2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.d0a8fa26.svg";
export { ForwardRef as ReactComponent };